import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '@/i18n';

interface LanguageSwitcherProps {
  className?: string;
  onDark?: boolean;
}

export function LanguageSwitcher({ className = '', onDark = false }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();
  const tone = onDark
    ? 'bg-conduril-light text-white border-conduril-soft'
    : 'bg-white text-gray-900 border-conduril-border';

  return (
    <select
      aria-label={t('language.label')}
      value={i18n.resolvedLanguage}
      onChange={(e) => void i18n.changeLanguage(e.target.value)}
      className={`h-10 rounded-lg border px-2 text-sm font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-conduril-light ${tone} ${className}`}
    >
      {supportedLanguages.map((lng) => (
        <option key={lng} value={lng}>
          {t(`language.${lng}`)}
        </option>
      ))}
    </select>
  );
}
